import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';

const routeNames = {
  '': 'Home',
  'centenary': 'Centenary',
  'projects': 'Projects',
  'initiatives': 'Initiatives',
  'planning': 'Planning News',
  'volunteering': 'Opportunities & Volunteering',
  'competition': 'Competition',
  'news': 'News',
  'about': 'About',
  'donate': 'Donate',
  'resources': 'Resources',
};

export const Breadcrumbs = ({ customItems, variant = 'default' }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const isLight = variant === 'light';

  const navClassName = cn(
    'flex items-center gap-2 text-sm mb-6',
    isLight ? 'text-white/80' : 'text-muted-foreground'
  );
  const linkClassName = cn(
    'transition-colors duration-200',
    isLight ? 'hover:text-white' : 'hover:text-foreground'
  );
  const currentClassName = cn(
    'font-medium',
    isLight ? 'text-white' : 'text-foreground'
  );

  if (customItems) {
    return (
      <nav className={navClassName} data-testid="breadcrumbs">
        <Link to="/" className={linkClassName}>
          <Home className="w-4 h-4" />
        </Link>
        {customItems.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4 shrink-0" />
            {item.href ? (
              <Link to={item.href} className={linkClassName}>
                {item.label}
              </Link>
            ) : (
              <span className={currentClassName}>{item.label}</span>
            )}
          </div>
        ))}
      </nav>
    );
  }

  if (pathnames.length === 0) return null;

  return (
    <nav className={navClassName} data-testid="breadcrumbs">
      <Link to="/" className={linkClassName}>
        <Home className="w-4 h-4" />
      </Link>
      {pathnames.map((pathname, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const name = routeNames[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);

        return (
          <div key={pathname} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4 shrink-0" />
            {isLast ? (
              <span className={currentClassName}>{name}</span>
            ) : (
              <Link to={routeTo} className={linkClassName}>
                {name}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
};
